import React, { useEffect, useState } from 'react';
import ClaimProfileHeader from '../auth/claimProfile/claimProfileStep1/ClaimProfileHeader';
import DashboardHeader from '../../layouts/header/DashboardHeader';
import { getAuthToken } from '../../../services/authService';
import RightFitImage from './assets/img/find-the-right-fit-img.png';
import TotalTransparencyImage from './assets/img/total-transparency-img.png';
import DataDrivenImage from './assets/img/data-driven-profile-mockup-img.png';
import ShowCoachImage from './assets/img/show-coaches-your-game-img.png';
import SuccessStoriesImage from './assets/img/success-stories-img-01.png';
import CallStateImage from './assets/img/cal-state-fullerton-titans-logo.png';
import AthleteThumbnail from './assets/img/athlete-video-thumbnail.png';
import OwlCarousel from 'react-owl-carousel';
import { fetchMethod } from '../../../services/httpService';
import './assets/css/lading-page.scss';
import { VideoPop } from './common/videoPopup';
import SuccessStories from '../../common/SuccessStories';
const helpSlide = {
  loop: true,
  nav: true,
  dots: false,
  items: 1,
};
const HighSchools = (props) => {
  const [headerType, setHeaderType] = useState(true),
    [highSchoolData, setHighSchoolData] = useState([]),
    [videoData, setVideoData] = useState([]),
    [isVideoPop, setIsVideoPop] = useState(false),
    [vidID, setVidID] = useState(null),
    isToken = props?.match?.params?.isToken == 1 ? true : false;
  useEffect(async () => {
    getHighSchoolData();
  }, []);
  const getHighSchoolData = async () => {
    const obj = {
      url: '/api/Landingpages/getlandingpagesVideos',
      method: 'post',
      data: {
        pagename: 'highschools',
      },
      headers: false,
    };
    const res = await fetchMethod(
      obj?.url,
      obj?.data,
      obj?.method,
      obj?.headers
    );
    if (res?.status == 200 && res?.data?.response?.data?.length > 0) {
      const allRecruitingActivity = res?.data?.response?.data?.filter(
        (item) => item?.title === 'allrecruitingactivity'
      );
      const videotestimonialData = res?.data?.response?.data?.filter(
        (item) => item?.title === 'videotestimonial'
      );
      setHighSchoolData(allRecruitingActivity);
      setVideoData(videotestimonialData);
    } else {
      setHighSchoolData([]);
      setVideoData([]);
    }
  };
  useEffect(() => {
    getStatus(props);
    //for scrolling the page on top
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 1000);
  }, []);
  const getStatus = (props) => {
    if (!!getAuthToken() || isToken) {
      setHeaderType(false);
    }
  };
  const openVidPopup = (vidLink) => {
    setVidID(vidLink);
    setTimeout(() => {
      setIsVideoPop(true);
    }, 500);
  };
  return (
    <>
      {headerType ? <ClaimProfileHeader /> : <DashboardHeader />}
      <section className="banner-lp-sec">
        <div className="container">
          <div className="banner-flexbox">
            <div className="banner-content">
              <h1 className="title">
                All Recruiting <br />
                Activity In One Place
              </h1>
              <div className="short-text">
                <p>
                  Lorem Ipsum has been the industry's standard dummy text ever
                  since the 1500s, when an unknown printer took a galley of type
                  and scrambled it to make a type specimen book.
                </p>
              </div>
              <div className="button-wrap">
                <a className="btn" href={void 0}>
                  Join Waiting List
                </a>
              </div>
            </div>
            <div className="video-box-wrap">
              <div className="video-img">
                {highSchoolData?.length > 0 ? (
                  <a href={highSchoolData?.[0]?.videolink} target="_blank">
                    <video
                      poster={
                        highSchoolData?.[0]?.videolink
                          ? highSchoolData?.[0]?.videolink
                          : null
                      }
                    >
                      <source
                        src={
                          highSchoolData?.[0]?.videolink
                            ? highSchoolData?.[0]?.videolink
                            : null
                        }
                        alt="video"
                      />
                    </video>
                  </a>
                ) : (
                  <img src={AthleteThumbnail} alt="" />
                )}
                <div className="video-play-button">
                  <div className="video-play-inner">
                    <button
                      className="play-btn"
                      onClick={() => {
                        openVidPopup(highSchoolData?.[0]?.videolink ?? null);
                        // window.open(highSchoolData?.[0]?.videolink, '_blank');
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20.191"
                        height="22.92"
                        viewBox="0 0 20.191 22.92"
                      >
                        <path
                          id="play"
                          d="M9.086,27.982a2.255,2.255,0,0,1-1.1-.291,2.442,2.442,0,0,1-1.228-2.138V7.492A2.442,2.442,0,0,1,7.982,5.353a2.242,2.242,0,0,1,2.257.028l15.641,9.24a2.226,2.226,0,0,1,0,3.8L10.236,27.663a2.262,2.262,0,0,1-1.151.319Z"
                          transform="translate(-6.754 -5.063)"
                          fill="#c0321f"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="collage-coache-sec">
        <div className="container">
          <div className="top-block">
            <h2 className="title">
              All the tools you need to empower your student athletes to pursue
              their dreams
            </h2>
            <p>
              Lorem Ipsum has been the industry's standard dummy text ever since
              the 1500s, when an unknown printer took a galley of type and
              scrambled it to make a type specimen book.
            </p>
          </div>
          <div className="collage-coach-list">
            <div className="item">
              <div className="detail-box">
                <div className="info-box">
                  <div className="icon-box">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="42"
                      height="42"
                      viewBox="0 0 42 42"
                    >
                      <g id="coach" transform="translate(-1.757 -14.819)">
                        <g
                          id="Group_2311"
                          data-name="Group 2311"
                          transform="translate(1.757 14.819)"
                        >
                          <g id="Group_2310" data-name="Group 2310">
                            <path
                              id="Path_83966"
                              data-name="Path 83966"
                              d="M40.239,31.765A8.742,8.742,0,0,0,33.4,24.72l-7.517-1.626h-.135V18.827a8.152,8.152,0,0,0,3.386-6.571V8.191a8.127,8.127,0,1,0-16.254,0v4.065a8.058,8.058,0,0,0,3.386,6.571v4.268h-.135L8.611,24.652A8.742,8.742,0,0,0,1.771,31.7L.01,41.249a.743.743,0,0,0,.542.813h40.77A.64.64,0,0,0,42,41.385v-.135ZM21,1.417a6.746,6.746,0,0,1,6.637,5.419H14.368A6.746,6.746,0,0,1,21,1.417Zm6.5,6.774-2.032,2.032h-8.94L14.5,8.191ZM14.232,12.256V9.817l1.558,1.558a.615.615,0,0,0,.474.2h9.482a.615.615,0,0,0,.474-.2l1.558-1.558v2.439a6.773,6.773,0,1,1-13.545,0Zm10.159,7.384v4.539l-.474.474a4.181,4.181,0,0,1-2.844,1.219h-.135a3.791,3.791,0,0,1-2.844-1.219l-.474-.474V19.639a8.067,8.067,0,0,0,6.773,0ZM14.91,24.788l1.151-.271L17.077,25.6a5.368,5.368,0,0,0,3.86,1.558h.135a5.484,5.484,0,0,0,3.86-1.558l1.084-1.084,1.151.271v2.168L23.578,31.7a3.339,3.339,0,0,0-4.741-.339L18.5,31.7,14.91,26.956ZM21,35.965a2.032,2.032,0,1,1,2.032-2.032V38H21.682V36.643A.64.64,0,0,0,21,35.965ZM10.169,40.707H1.5l.271-1.355h8.4Zm20.318.068H11.523V31.9H10.169V38H1.974l1.084-6.029a7.446,7.446,0,0,1,5.824-5.961l4.673-1.016v2.168a.963.963,0,0,0,.135.406l4.064,5.419a4,4,0,0,0-.135.948,3.407,3.407,0,0,0,2.709,3.319v1.423a.64.64,0,0,0,.677.677h2.709a.64.64,0,0,0,.677-.677V33.933a4,4,0,0,0-.135-.948l4.064-5.419a.963.963,0,0,0,.135-.406v-2.1l4.673,1.016a7.446,7.446,0,0,1,5.824,5.961l1.084,6.029H31.841v-6.1H30.486Zm1.355-.068V39.352h8.4l.271,1.355Z"
                              transform="translate(0 -0.062)"
                            ></path>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </div>
                  Showcase your athletes
                </div>
                <p>
                  Lorem Ipsum has been the industry's standard dummy text ever
                  since the 1500s, when an
                </p>
              </div>
            </div>
            <div className="item">
              <div className="detail-box">
                <div className="info-box">
                  <div className="icon-box">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="42.712"
                      height="42.712"
                      viewBox="0 0 42.712 42.712"
                    >
                      <path
                        id="_001-send"
                        data-name="001-send"
                        d="M41.64.361A1.231,1.231,0,0,0,40.416.052L2.773,11.345a3.869,3.869,0,0,0,.017,7.427l15.9,4.542,4.542,15.9a3.869,3.869,0,0,0,7.427.017L41.948,1.584A1.23,1.23,0,0,0,41.64.361ZM2.461,15.072A1.422,1.422,0,0,1,3.48,13.7l32.968-9.89L19.324,20.936,3.466,16.405a1.392,1.392,0,0,1-1.005-1.333ZM28.3,38.52a1.422,1.422,0,0,1-1.371,1.019,1.392,1.392,0,0,1-1.332-1.005L21.064,22.676,38.189,5.552Z"
                        transform="translate(0.35 0.361)"
                        stroke="#fff8ec"
                        strokeWidth="0.7"
                      ></path>
                    </svg>
                  </div>
                  Built in Messaging (Comming Soon)
                </div>
                <p>
                  Lorem Ipsum has been the industry's standard dummy text ever
                  since the 1500s, when an
                </p>
              </div>
            </div>
            <div className="item">
              <div className="detail-box">
                <div className="info-box">
                  <div className="icon-box">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="42"
                      height="42"
                      viewBox="0 0 42 42"
                    >
                      <g
                        id="_002-search"
                        data-name="002-search"
                        transform="translate(0 0)"
                      >
                        <path
                          id="Path_83970"
                          data-name="Path 83970"
                          d="M16.534,30.067a13.533,13.533,0,0,0,9.57-23.1A13.534,13.534,0,1,0,6.964,26.1,13.447,13.447,0,0,0,16.534,30.067ZM7.833,7.833a12.3,12.3,0,1,1-3.6,8.7,12.225,12.225,0,0,1,3.6-8.7Z"
                          transform="translate(-0.034 -0.033)"
                        ></path>
                        <path
                          id="Path_83971"
                          data-name="Path 83971"
                          d="M16.406,32.811a16.279,16.279,0,0,0,10.123-3.5l2.078,2.078-.464.464a.656.656,0,0,0,0,.928L36.4,41.039a3.281,3.281,0,1,0,4.64-4.638h0l-8.256-8.258a.656.656,0,0,0-.928,0l-.465.465-2.078-2.078a16.4,16.4,0,1,0-12.906,6.283Zm23.7,7.3a2.014,2.014,0,0,1-2.783,0l-7.792-7.792L30,31.856h0L31.852,30l0,0,0,0,.462-.463,7.792,7.794h0a1.966,1.966,0,0,1,0,2.783ZM30.462,29.535l-.927.929-2-2c.16-.148.32-.3.476-.452s.3-.315.452-.476ZM5.733,5.733A15.094,15.094,0,1,1,27.079,27.078,15.094,15.094,0,0,1,5.733,5.733Z"
                        ></path>
                        <path
                          id="Path_83972"
                          data-name="Path 83972"
                          d="M13.611,26.572a1.983,1.983,0,0,0,1.98,1.98h7.92a1.984,1.984,0,0,0,1.981-1.981V21.988l3.3-1.1v3.043a.66.66,0,1,0,1.32,0V19.972h0s0,0,0,0a.672.672,0,0,0-.046-.227.685.685,0,0,0-.038-.073.615.615,0,0,0-.083-.123.666.666,0,0,0-.064-.065.646.646,0,0,0-.117-.079.59.59,0,0,0-.084-.043c-.007,0-.013-.009-.02-.011l-9.9-3.3a.665.665,0,0,0-.418,0l-9.9,3.3a.659.659,0,0,0,0,1.251l4.169,1.389v4.585Zm10.561,0a.662.662,0,0,1-.659.661H15.591a.66.66,0,0,1-.66-.66V22.428L19.343,23.9a.651.651,0,0,0,.417,0l4.412-1.471Zm-4.621-9.2L25.38,19.31H19.551a.66.66,0,1,0,0,1.32h5.837l-5.837,1.946-7.813-2.6Z"
                          transform="translate(-3.056 -5.53)"
                        ></path>
                      </g>
                    </svg>
                  </div>
                  Find the right fit
                </div>
                <p>
                  Lorem Ipsum has been the industry's standard dummy text ever
                  since the 1500s, when an
                </p>
              </div>
            </div>
            <div className="item">
              <div className="detail-box">
                <div className="info-box">
                  <div className="icon-box">
                    <svg
                      id="_003-target"
                      data-name="003-target"
                      xmlns="http://www.w3.org/2000/svg"
                      width="42"
                      height="42"
                      viewBox="0 0 42 42"
                    >
                      <path
                        id="Path_83973"
                        data-name="Path 83973"
                        d="M15.61,21.331a14.3,14.3,0,0,1-7.373-2.189A2.576,2.576,0,0,1,7,16.929V11.861a.861.861,0,0,1,1.722,0v5.068a.863.863,0,0,0,.394.735,11.763,11.763,0,0,0,12.985,0,.86.86,0,0,0,.4-.735V11.861a.861.861,0,0,1,1.722,0v5.068a2.576,2.576,0,0,1-1.236,2.214A14.3,14.3,0,0,1,15.61,21.331Z"
                        transform="translate(5.39 8.353)"
                      ></path>
                      <path
                        id="Path_83974"
                        data-name="Path 83974"
                        d="M17.39,19.054a.907.907,0,0,1-.372-.079L5.513,13.809a.852.852,0,0,1,0-1.563L17.019,7.08a.9.9,0,0,1,.743,0l11.505,5.166a.852.852,0,0,1,0,1.563L17.762,18.975a.907.907,0,0,1-.372.079ZM8,13.027l9.394,4.217,9.394-4.217L17.39,8.81Z"
                        transform="translate(3.61 5.331)"
                      ></path>
                      <path
                        id="Path_83975"
                        data-name="Path 83975"
                        d="M19.917,38.334A18.417,18.417,0,1,1,38.334,19.917,18.437,18.437,0,0,1,19.917,38.334Zm0-35.08A16.663,16.663,0,1,0,36.58,19.917,16.683,16.683,0,0,0,19.917,3.254Z"
                        transform="translate(1.083 1.083)"
                      ></path>
                      <path
                        id="Path_83976"
                        data-name="Path 83976"
                        d="M12.361,6.888a.861.861,0,0,1-.861-.861V.861a.861.861,0,0,1,1.722,0V6.027A.861.861,0,0,1,12.361,6.888Z"
                        transform="translate(8.639)"
                      ></path>
                      <path
                        id="Path_83977"
                        data-name="Path 83977"
                        d="M12.361,26.888a.861.861,0,0,1-.861-.861V20.861a.861.861,0,1,1,1.722,0v5.166A.861.861,0,0,1,12.361,26.888Z"
                        transform="translate(8.639 15.112)"
                      ></path>
                      <path
                        id="Path_83978"
                        data-name="Path 83978"
                        d="M26.027,13.222H20.861a.861.861,0,1,1,0-1.722h5.166a.861.861,0,0,1,0,1.722Z"
                        transform="translate(15.112 8.639)"
                      ></path>
                      <path
                        id="Path_83979"
                        data-name="Path 83979"
                        d="M6.027,13.222H.861a.861.861,0,0,1,0-1.722H6.027a.861.861,0,0,1,0,1.722Z"
                        transform="translate(0 8.639)"
                      ></path>
                    </svg>
                  </div>
                  Total Transparency
                </div>
                <p>
                  Lorem Ipsum has been the industry's standard dummy text ever
                  since the 1500s, when an
                </p>
              </div>
            </div>
            <div className="item">
              <div className="detail-box">
                <div className="info-box">
                  <div className="icon-box">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="39.775"
                      height="42.4"
                      viewBox="0 0 39.775 42.4"
                    >
                      <g
                        id="_004-american-football-player"
                        data-name="004-american-football-player"
                        transform="translate(0.2 0.2)"
                      >
                        <path
                          id="Path_83980"
                          data-name="Path 83980"
                          d="M180.82,450.641a.82.82,0,1,0-.82-.82A.821.821,0,0,0,180.82,450.641Zm0,0"
                          transform="translate(-165.234 -412.168)"
                          stroke="#e5f8ff"
                          strokeWidth="0.4"
                        ></path>
                        <path
                          id="Path_83981"
                          data-name="Path 83981"
                          d="M0,30.844a.82.82,0,0,0,.82.82h.82v2.461a.82.82,0,0,0,.82.82h.82V41.18A.82.82,0,0,0,4.1,42H35.274a.82.82,0,0,0,.82-.82V34.946h.82a.82.82,0,0,0,.82-.82V31.664h.82a.82.82,0,0,0,.82-.82,9.034,9.034,0,0,0-9.023-9.023H24.927A9.169,9.169,0,0,0,28.8,15.413c.775-6.475.731-6.067.731-6.143A9.233,9.233,0,0,0,20.508,0H18.867A9.234,9.234,0,0,0,9.844,9.27c0,.085-.037-.268.732,6.147a9.173,9.173,0,0,0,3.871,6.4H9.023A9.034,9.034,0,0,0,0,30.844Zm8.187.82c.01.113.016.227.016.341v1.3H3.281V31.664ZM4.922,34.946H8.2V40.36H4.922ZM26.25,40.36H13.125V34.946H26.25Zm8.2,0H31.172V34.946h3.281ZM36.094,33.3H31.172v-1.3c0-.114.006-.228.016-.341h4.906ZM13.839,23.461l5.3,4.715a.82.82,0,0,0,1.09,0l5.3-4.715h2.47L21.322,29.4a2.46,2.46,0,0,1-3.269,0l-6.684-5.941Zm-1.486-7.43a7.6,7.6,0,0,1-.149-.814l-.294-2.454.865,1.388a2.454,2.454,0,0,0,2.015,1.1l.289,1.322a24.274,24.274,0,0,1-2.726-.547Zm14.82-.817a7.575,7.575,0,0,1-.149.817,24.288,24.288,0,0,1-2.726.547l.289-1.322a2.454,2.454,0,0,0,2.015-1.1l.865-1.388Zm-4.265.044-.332,1.518c-.678.059-1.369.1-2.066.113V15.258Zm-2.4,3.272q.857-.02,1.7-.08l-.689,3.145a7.489,7.489,0,0,1-1.011.181Zm-1.641-1.641c-.7-.017-1.388-.055-2.066-.113l-.332-1.518h2.4Zm0,1.641v3.246a7.439,7.439,0,0,1-1.011-.181l-.689-3.145q.841.06,1.7.08Zm6.359-5.274a.819.819,0,0,1-.68.361H14.829a.819.819,0,0,1-.68-.361L12.178,10.09H27.2ZM16.308,23.461h6.759l-3.38,3Zm7.05-2.593.566-2.584c.831-.1,1.629-.236,2.389-.4a7.562,7.562,0,0,1-2.955,2.982ZM20.508,1.641a7.035,7.035,0,0,1,2.81.592L21.668,5.168H17.707L16.057,2.233a7.035,7.035,0,0,1,2.81-.592ZM14.637,3.054,16.511,6.39a.821.821,0,0,0,.715.418h4.922a.821.821,0,0,0,.715-.418l1.875-3.336a7.738,7.738,0,0,1,3.108,5.4H11.529a7.738,7.738,0,0,1,3.108-5.4ZM13.063,17.886c.76.162,1.559.294,2.389.4l.566,2.585a7.533,7.533,0,0,1-2.955-2.982ZM8.9,23.464l8.06,7.164a4.1,4.1,0,0,0,5.449,0l8.06-7.165a7.393,7.393,0,0,1,7.217,6.56H31.679l1.048-2.094a.82.82,0,0,0-1.467-.734c-.871,1.808-1.727,2.93-1.727,4.81V40.36H27.891V34.125a.82.82,0,0,0-.82-.82H12.3a.82.82,0,0,0-.82.82V40.36H9.844V32.005c0-1.952-.906-3-1.727-4.81a.82.82,0,1,0-1.467.734L7.7,30.024H1.686A7.393,7.393,0,0,1,8.9,23.464Zm0,0"
                          stroke="#e5f8ff"
                          strokeWidth="0.4"
                        ></path>
                        <path
                          id="Path_83982"
                          data-name="Path 83982"
                          d="M220.82,450.641h4.922a.82.82,0,0,0,0-1.641H220.82a.82.82,0,1,0,0,1.641Zm0,0"
                          transform="translate(-201.953 -412.168)"
                          stroke="#e5f8ff"
                          strokeWidth="0.4"
                        ></path>
                      </g>
                    </svg>
                  </div>
                  Showcase your athletes
                </div>
                <p>
                  Lorem Ipsum has been the industry's standard dummy text ever
                  since the 1500s, when an
                </p>
              </div>
            </div>
            <div className="item">
              <div className="detail-box">
                <div className="info-box">
                  <div className="icon-box">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="43.5"
                      height="43.5"
                      viewBox="0 0 43.5 43.5"
                    >
                      <path
                        id="_005-video-tutorial"
                        data-name="005-video-tutorial"
                        d="M29.667,13.01,16.761,8.2a1.641,1.641,0,0,0-2.214,1.537v9.625A1.642,1.642,0,0,0,16.761,20.9l12.906-4.813A1.642,1.642,0,0,0,29.667,13.01ZM17.828,17V12.1l6.57,2.45ZM37.078,0H4.922A4.927,4.927,0,0,0,0,4.922v19.25a4.927,4.927,0,0,0,4.922,4.922H37.078A4.927,4.927,0,0,0,42,24.172V4.922A4.927,4.927,0,0,0,37.078,0Zm1.641,24.172a1.642,1.642,0,0,1-1.641,1.641H4.922a1.642,1.642,0,0,1-1.641-1.641V4.922A1.642,1.642,0,0,1,4.922,3.281H37.078a1.642,1.642,0,0,1,1.641,1.641Zm-1.586,11.32h-5.1a4.867,4.867,0,0,0-9.164,0h-18a1.641,1.641,0,0,0,0,3.281h18a4.867,4.867,0,0,0,9.164,0h5.1a1.641,1.641,0,0,0,0-3.281Zm-9.68,3.227a1.586,1.586,0,1,1,1.586-1.586A1.588,1.588,0,0,1,27.453,38.719Z"
                        transform="translate(0.75 0.75)"
                        stroke="#e5f8ff"
                        strokeWidth="1.5"
                      ></path>
                    </svg>
                  </div>
                  Unlimited video from any source
                </div>
                <p>
                  Lorem Ipsum has been the industry's standard dummy text ever
                  since the 1500s, when an
                </p>
              </div>
            </div>
            <div className="item">
              <div className="detail-box">
                <div className="info-box">
                  <div className="icon-box">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40.113"
                      height="42"
                      viewBox="0 0 40.113 42"
                    >
                      <g
                        id="_007-opinion"
                        data-name="007-opinion"
                        transform="translate(-0.001 0)"
                      >
                        <path
                          id="Path_83983"
                          data-name="Path 83983"
                          d="M63.488,344.638a3.718,3.718,0,0,1-3.5,0,.615.615,0,0,0-.592,1.079,4.947,4.947,0,0,0,4.683,0,.616.616,0,1,0-.594-1.079Zm0,0"
                          transform="translate(-54.231 -316.297)"
                        ></path>
                        <path
                          id="Path_83984"
                          data-name="Path 83984"
                          d="M70.914,313.588a.615.615,0,1,1-.615-.615A.616.616,0,0,1,70.914,313.588Zm0,0"
                          transform="translate(-63.965 -287.299)"
                        ></path>
                        <path
                          id="Path_83985"
                          data-name="Path 83985"
                          d="M99.547,313.588a.615.615,0,1,1-.615-.615A.615.615,0,0,1,99.547,313.588Zm0,0"
                          transform="translate(-90.25 -287.299)"
                        ></path>
                        <path
                          id="Path_83986"
                          data-name="Path 83986"
                          d="M39.267,286.065a.615.615,0,1,0-1.091.569,6.207,6.207,0,0,1,.708,2.9v.01a1.838,1.838,0,0,1-1.836,1.836H28.169a1.835,1.835,0,0,1-1.015-.307,3.047,3.047,0,0,0,.41-1.529v-.01a7.467,7.467,0,0,0-.556-2.834,6.276,6.276,0,0,1,9.694-1.924.615.615,0,0,0,.8-.932,7.491,7.491,0,0,0-2.24-1.331,5.127,5.127,0,1,0-5.312,0,7.536,7.536,0,0,0-3.622,2.9,7.546,7.546,0,0,0-3.616-2.9,5.127,5.127,0,1,0-5.315,0,7.548,7.548,0,0,0-3.617,2.905,7.508,7.508,0,0,0-3.616-2.907,5.127,5.127,0,1,0-5.319,0,7.486,7.486,0,0,0-2.584,1.649.615.615,0,1,0,.859.881,6.277,6.277,0,0,1,9.984,1.658,7.469,7.469,0,0,0-.556,2.834v.01a3.047,3.047,0,0,0,.41,1.529,1.835,1.835,0,0,1-1.015.307H3.067a1.838,1.838,0,0,1-1.836-1.836v-.01a6.237,6.237,0,0,1,.513-2.49.615.615,0,1,0-1.129-.488A7.458,7.458,0,0,0,0,289.533v.01a3.07,3.07,0,0,0,3.066,3.067h8.879A3.065,3.065,0,0,0,13.782,292a3.049,3.049,0,0,0,1.835.612H24.5A3.047,3.047,0,0,0,26.333,292a3.065,3.065,0,0,0,1.836.612h8.879a3.07,3.07,0,0,0,3.066-3.067v-.01a7.527,7.527,0,0,0-.847-3.468Zm-10.555-7.937a3.9,3.9,0,1,1,3.9,3.9A3.9,3.9,0,0,1,28.712,278.128Zm-25.1,0a3.9,3.9,0,1,1,3.9,3.9A3.9,3.9,0,0,1,3.61,278.128Zm12.551,0a3.9,3.9,0,1,1,3.9,3.9A3.9,3.9,0,0,1,16.161,278.128Zm-.543,13.252a1.838,1.838,0,0,1-1.836-1.836v-.01a6.275,6.275,0,1,1,12.551,0v.01a1.838,1.838,0,0,1-1.836,1.836Zm0,0"
                          transform="translate(0 -250.61)"
                        ></path>
                        <path
                          id="Path_83987"
                          data-name="Path 83987"
                          d="M369.488,344.638a3.718,3.718,0,0,1-3.5,0,.615.615,0,0,0-.592,1.079,4.947,4.947,0,0,0,4.683,0,.616.616,0,1,0-.594-1.079Zm0,0"
                          transform="translate(-335.133 -316.297)"
                        ></path>
                        <path
                          id="Path_83988"
                          data-name="Path 83988"
                          d="M376.915,313.588a.615.615,0,1,1-.615-.615A.616.616,0,0,1,376.915,313.588Zm0,0"
                          transform="translate(-344.866 -287.299)"
                        ></path>
                        <path
                          id="Path_83989"
                          data-name="Path 83989"
                          d="M405.547,313.588a.615.615,0,1,1-.615-.615A.615.615,0,0,1,405.547,313.588Zm0,0"
                          transform="translate(-371.15 -287.299)"
                        ></path>
                        <path
                          id="Path_83990"
                          data-name="Path 83990"
                          d="M216.488,344.638a3.718,3.718,0,0,1-3.5,0,.615.615,0,0,0-.592,1.079,4.947,4.947,0,0,0,4.683,0,.616.616,0,1,0-.594-1.079Zm0,0"
                          transform="translate(-194.682 -316.297)"
                        ></path>
                        <path
                          id="Path_83991"
                          data-name="Path 83991"
                          d="M223.915,313.588a.615.615,0,1,1-.615-.615A.616.616,0,0,1,223.915,313.588Zm0,0"
                          transform="translate(-204.416 -287.299)"
                        ></path>
                        <path
                          id="Path_83992"
                          data-name="Path 83992"
                          d="M252.547,313.588a.615.615,0,1,1-.615-.615A.615.615,0,0,1,252.547,313.588Zm0,0"
                          transform="translate(-230.7 -287.299)"
                        ></path>
                        <path
                          id="Path_83993"
                          data-name="Path 83993"
                          d="M287.615,91.489h8.7a.615.615,0,0,0,0-1.231h-8.7a.615.615,0,0,0,0,1.231Zm0,0"
                          transform="translate(-263.458 -82.854)"
                        ></path>
                        <path
                          id="Path_83994"
                          data-name="Path 83994"
                          d="M287.615,121.489h8.7a.615.615,0,0,0,0-1.231h-8.7a.615.615,0,0,0,0,1.231Zm0,0"
                          transform="translate(-263.458 -110.393)"
                        ></path>
                        <path
                          id="Path_83995"
                          data-name="Path 83995"
                          d="M287.615,151.489h8.7a.615.615,0,0,0,0-1.231h-8.7a.615.615,0,0,0,0,1.231Zm0,0"
                          transform="translate(-263.458 -137.932)"
                        ></path>
                        <path
                          id="Path_83996"
                          data-name="Path 83996"
                          d="M26.715,17.088h2.946a4.88,4.88,0,0,0,1.7,3.487,3.97,3.97,0,0,0,2.435.759,5.785,5.785,0,0,0,1.213-.133.708.708,0,0,0-.025-1.39,1.1,1.1,0,0,1-.8-.509,3.471,3.471,0,0,1-.173-2.213h3.8a4.192,4.192,0,0,0,1.866-.437,4.245,4.245,0,0,0,3.938,2.714h3.8a3.467,3.467,0,0,1-.173,2.214,1.1,1.1,0,0,1-.8.509.711.711,0,0,0-.583.684.7.7,0,0,0,.558.706,5.782,5.782,0,0,0,1.213.133,3.972,3.972,0,0,0,2.436-.759,4.88,4.88,0,0,0,1.7-3.487h2.946a4.218,4.218,0,0,0,4.215-4.213V6.491a4.218,4.218,0,0,0-4.215-4.213H43.613a4.233,4.233,0,0,0-1.866.436A4.221,4.221,0,0,0,37.809,0h-7.6a.615.615,0,0,0,0,1.231h7.6a2.986,2.986,0,0,1,2.984,2.982v8.663a2.986,2.986,0,0,1-2.984,2.982H33.522a.615.615,0,0,0-.59.441,5.132,5.132,0,0,0,.2,3.648c.023.037.046.073.071.108a2.5,2.5,0,0,1-1.1-.461,4.091,4.091,0,0,1-1.268-3.158.616.616,0,0,0-.614-.579h-3.51a2.986,2.986,0,0,1-2.984-2.982V4.213a2.986,2.986,0,0,1,2.984-2.982h.872a.615.615,0,0,0,0-1.231h-.872A4.218,4.218,0,0,0,22.5,4.213v8.663a4.218,4.218,0,0,0,4.214,4.213Zm15.309-4.213V4.213c0-.081,0-.162-.007-.241a2.949,2.949,0,0,1,1.6-.463H54.707a2.986,2.986,0,0,1,2.984,2.982v8.662a2.987,2.987,0,0,1-2.984,2.982H51.2a.616.616,0,0,0-.614.579,4.092,4.092,0,0,1-1.267,3.158,2.5,2.5,0,0,1-1.1.461c.025-.036.048-.071.071-.109a5.131,5.131,0,0,0,.2-3.648.615.615,0,0,0-.59-.441H43.613a3,3,0,0,1-2.886-2.224,4.2,4.2,0,0,0,1.3-3.035Zm0,0"
                          transform="translate(-20.653)"
                        ></path>
                        <path
                          id="Path_83997"
                          data-name="Path 83997"
                          d="M72,50.02c0,1.292.671,3.815,5.168,6.194a1.143,1.143,0,0,0,1.069,0c4.5-2.379,5.168-4.9,5.168-6.194a3.318,3.318,0,0,0-3.159-3.52,3.749,3.749,0,0,0-2.544,1,3.749,3.749,0,0,0-2.544-1A3.318,3.318,0,0,0,72,50.02Zm3.159-2.289a2.51,2.51,0,0,1,1.814.778,1.026,1.026,0,0,0,1.459,0,2.509,2.509,0,0,1,1.814-.778,2.1,2.1,0,0,1,1.928,2.289c0,1.72-1.629,3.572-4.472,5.084-2.843-1.513-4.472-3.364-4.472-5.084a2.1,2.1,0,0,1,1.928-2.289Zm0,0"
                          transform="translate(-66.091 -42.684)"
                        ></path>
                      </g>
                    </svg>
                  </div>
                  Seamless integration with your website
                </div>
                <p>
                  Lorem Ipsum has been the industry's standard dummy text ever
                  since the 1500s, when an
                </p>
              </div>
            </div>
            <div className="item">
              <div className="detail-box">
                <div className="info-box">
                  <div className="icon-box">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="39.3"
                      height="42.8"
                      viewBox="0 0 39.3 42.8"
                    >
                      <g
                        id="_008-notification"
                        data-name="008-notification"
                        transform="translate(0.4 0.4)"
                      >
                        <path
                          id="Path_83998"
                          data-name="Path 83998"
                          d="M140.036,424.045a6.713,6.713,0,0,1-6.7-6.7,1.341,1.341,0,0,1,2.682,0,4.023,4.023,0,1,0,8.045,0,1.341,1.341,0,0,1,2.682,0A6.712,6.712,0,0,1,140.036,424.045Zm0,0"
                          transform="translate(-122.517 -382.045)"
                          stroke="#e5f8ff"
                          strokeWidth="0.8"
                        ></path>
                        <path
                          id="Path_83999"
                          data-name="Path 83999"
                          d="M31.868,95.273H3.056a3.038,3.038,0,0,1-1.987-5.351,1.205,1.205,0,0,1,.14-.1,11.652,11.652,0,0,0,4.03-8.809V76.162A12.207,12.207,0,0,1,17.462,64a5.287,5.287,0,0,1,.861.052,1.3,1.3,0,1,1-.43,2.57,2.763,2.763,0,0,0-.431-.016,9.591,9.591,0,0,0-9.6,9.556v4.847A14.26,14.26,0,0,1,2.789,91.9c-.026.021-.049.04-.077.059a.429.429,0,0,0-.092.269.44.44,0,0,0,.436.434H31.868a.44.44,0,0,0,.437-.434.414.414,0,0,0-.094-.269c-.026-.019-.049-.038-.075-.059a14.257,14.257,0,0,1-5.069-10.9V79.116a1.31,1.31,0,0,1,2.619,0v1.893a11.656,11.656,0,0,0,4.035,8.814,1.272,1.272,0,0,1,.134.1,3.037,3.037,0,0,1-1.987,5.349Zm0,0"
                          transform="translate(0 -58.637)"
                          stroke="#e5f8ff"
                          strokeWidth="0.8"
                        ></path>
                        <path
                          id="Path_84000"
                          data-name="Path 84000"
                          d="M264.939,17.878a8.939,8.939,0,1,1,8.939-8.939A8.949,8.949,0,0,1,264.939,17.878Zm0-15.2A6.257,6.257,0,1,0,271.2,8.939a6.264,6.264,0,0,0-6.257-6.257Zm0,0"
                          transform="translate(-235.378)"
                          stroke="#e5f8ff"
                          strokeWidth="0.8"
                        ></path>
                      </g>
                    </svg>
                  </div>
                  Notifications
                </div>
                <p>
                  Lorem Ipsum has been the industry's standard dummy text ever
                  since the 1500s, when an
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="get-started-sec">
        <div className="container">
          <h3 className="sec-title">
            Ready to take your athletic department to the next level?
          </h3>
          <div className="short-text">
            <p>We can't wait to have you on board!</p>
          </div>
          <div className="button-wrap">
            <a className="btn" href={void 0}>
              Join waiting list
            </a>
          </div>
        </div>
      </section>
      <section className="athlete-common-sec">
        <div className="container">
          <div className="common-listing">
            <div className="item-row">
              <div className="content-box">
                <div className="top-block">
                  <div className="tagline">ADVANCED SCHOOL SEARCH</div>
                  <h3 className="title">Find the Right Fit</h3>
                </div>
                <div className="detail-text">
                  <p>
                    Lorem Ipsum has been the industry's standard dummy text ever
                    since the 1500s, when an unknown
                  </p>
                  <ul>
                    <li>Search by location, zip, division, conference, etc.</li>
                    <li>Filter schools by majors offered.</li>
                    <li>Every college and university at your fingertips.</li>
                  </ul>
                  <div className="button-wrap">
                    <button className="btn blue">Join Waiting List</button>
                  </div>
                </div>
              </div>
              <div className="img-box">
                <img src={RightFitImage} alt="" />
              </div>
            </div>
            <div className="item-row">
              <div className="content-box">
                <div className="top-block">
                  <div className="tagline">MASSAGING SYSTEM</div>
                  <h3 className="title">Easy contact with anyone</h3>
                </div>
                <div className="detail-text">
                  <p>
                    Lorem Ipsum has been the industry's standard dummy text ever
                    since the 1500s, when an unknown printer took a galley of
                    type and scrambled it to make a type specimen book.
                  </p>
                  <ul>
                    <li>Lorem been the industry's standard dummy</li>
                    <li>Lorem been the industry's standard dummy</li>
                    <li>Lorem been the industry's standard dummy</li>
                  </ul>
                  <div className="button-wrap">
                    <button className="btn blue">Join Waiting List</button>
                  </div>
                </div>
              </div>
              <div className="img-box">
                <img src={TotalTransparencyImage} alt="" />
              </div>
            </div>
            <div className="item-row">
              <div className="content-box">
                <div className="top-block">
                  <div className="tagline">TARGET LIST OF SCHOOL</div>
                  <h3 className="title">Stay organized</h3>
                </div>
                <div className="detail-text">
                  <p>
                    Lorem Ipsum has been the industry's standard dummy text ever
                    since the 1500s, when an unknown printer took a galley of
                    type and scrambled it to make a type specimen book.
                  </p>
                  <ul>
                    <li>Lorem been the industry's standard dummy</li>
                    <li>Lorem Ipsum has been the industry</li>
                    <li>Ipsum has been the industry's dummy</li>
                  </ul>
                  <div className="button-wrap">
                    <button className="btn blue">Join Waiting List</button>
                  </div>
                </div>
              </div>
              <div className="img-box">
                <img src={ShowCoachImage} alt="" />
              </div>
            </div>
            <div className="item-row">
              <div className="content-box">
                <div className="top-block">
                  <div className="tagline">ACTIVITY FEED + NOTIFICATIONS</div>
                  <h3 className="title">Total Transparency</h3>
                </div>
                <div className="detail-text">
                  <p>
                    Lorem Ipsum has been the industry's standard dummy text ever
                    since the 1500s, when an unknown printer took a galley of
                    type and scrambled it to make a type specimen book.
                  </p>
                  <ul>
                    <li>Lorem been the industry's standard dummy</li>
                    <li>Lorem been the industry's standard dummy</li>
                    <li>Lorem been the industry's standard dummy</li>
                  </ul>
                  <div className="button-wrap">
                    <button className="btn blue">Join Waiting List</button>
                  </div>
                </div>
              </div>
              <div className="img-box">
                <img src={TotalTransparencyImage} alt="" />
              </div>
            </div>
            <div className="item-row">
              <div className="content-box">
                <div className="top-block">
                  <div className="tagline">VIDEO + HIGHLIGHT REELS</div>
                  <h3 className="title">Unlimited Video for Your Athletes</h3>
                </div>
                <div className="detail-text">
                  <p>
                    Lorem Ipsum has been the industry's standard dummy text ever
                    since the 1500s, when an unknown printer took a galley of
                    type and scrambled it to make a type specimen book.
                  </p>
                  <ul>
                    <li>Lorem been the industry's standard dummy</li>
                    <li>Lorem Ipsum has been the industry</li>
                    <li>Ipsum has been the industry's dummy</li>
                  </ul>
                  <div className="button-wrap">
                    <button className="btn blue">Join Waiting List</button>
                  </div>
                </div>
              </div>
              <div className="img-box">
                <img src={ShowCoachImage} alt="" />
              </div>
            </div>
            <div className="item-row">
              <div className="content-box">
                <div className="top-block">
                  <div className="tagline">STUDENT-ATHLETE PROFILE</div>
                  <h3 className="title">Showcase your athletes</h3>
                </div>
                <div className="detail-text">
                  <p>
                    Lorem Ipsum has been the industry's standard dummy text ever
                    since the 1500s, when an unknown printer took a galley of
                    type and scrambled it to make a type specimen book.
                  </p>
                  <ul>
                    <li>
                      Find schools that fit your athletic and academic goals.
                    </li>
                    <li>
                      Filter schools by location, division, test scores, etc.
                    </li>
                    <li>
                      Build your target list of schools with the click of a
                      button.
                    </li>
                  </ul>
                  <div className="button-wrap">
                    <button className="btn blue">Join Waiting List</button>
                  </div>
                </div>
              </div>
              <div className="img-box">
                <img src={DataDrivenImage} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <SuccessStories />

      <section className="common-testimonial-sec">
        <div className="container">
          <div className="top-block">
            <h2 className="title">Video Testimonial</h2>
            <p>
              Lorem Ipsum has been the industry's standard dummy text ever since
              the 1500s, when an unknown printer took a galley of type and
              scrambled it to make a type specimen book.
            </p>
          </div>
          <ul className="videos-listing">
            {videoData?.length > 0
              ? videoData?.map((item) => {
                  return (
                    <li className="video-box" data-toggle="modal">
                      <div className="img-box">
                        <video poster={item?.videolink || null}>
                          <source src={item?.videolink || null} alt="video" />
                        </video>
                        <div className="video-play-button">
                          <div className="video-play-inner">
                            <button
                              className="play-btn"
                              onClick={() => {
                                openVidPopup(item?.videolink ?? null);
                                // window.open(item?.videolink, '_blank');
                              }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20.191"
                                height="22.92"
                                viewBox="0 0 20.191 22.92"
                              >
                                <path
                                  id="play"
                                  d="M9.086,27.982a2.255,2.255,0,0,1-1.1-.291,2.442,2.442,0,0,1-1.228-2.138V7.492A2.442,2.442,0,0,1,7.982,5.353a2.242,2.242,0,0,1,2.257.028l15.641,9.24a2.226,2.226,0,0,1,0,3.8L10.236,27.663a2.262,2.262,0,0,1-1.151.319Z"
                                  transform="translate(-6.754 -5.063)"
                                  fill="#c0321f"
                                />
                              </svg>
                            </button>
                          </div>
                        </div>
                        <span className="video-times">1 MIN</span>
                      </div>
                      <div className="video-detail-box">
                        {item?.content || ''}
                      </div>
                    </li>
                  );
                })
              : ''}
          </ul>
          <div className="btn-wrap">
            <button className="btn lightblue">Load more</button>
          </div>
        </div>
      </section>
      <VideoPop
        vidID={vidID}
        setIsTestSingle={() => setIsVideoPop(false)}
        isTestSingle={isVideoPop}
      />
    </>
  );
};
export default HighSchools;
